import * as React from 'react';
import ConfirmationPopup from 'components/Popup/Confirmation';

const styles = require('./styles.pcss');

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  pnr: string;
  bookingPrice: number;
};

const RedeemCRCPointsPopup = (props: Props) => {
  // bookingPrice can be null (e.g. a booking with its price zeroed out after a
  // duplicate-charge correction) rather than just missing, so coalesce explicitly.
  const bookingPrice = props.bookingPrice ?? 0;
  const pointsToRedeem = bookingPrice * 100;
  return (
    <ConfirmationPopup
      open={props.open}
      onClose={props.onClose}
      onSubmit={props.onSubmit}
      title="Redeem CRC Points"
      bodyText={
        <div>
          <p>{`Confirm the CRC reward points redemption for booking ${props.pnr}.`}</p>
          <div className={styles.crcRedeemRow}>
            <span>Booking price</span>
            <span>${bookingPrice.toFixed(2)}</span>
          </div>
          <div className={styles.crcRedeemDivider} />
          <div className={styles.crcRedeemRow}>
            <span>Points to Redeem</span>
            <span>{pointsToRedeem.toLocaleString()} pts</span>
          </div>
        </div>
      }
      submitButtonText="Confirm redemption"
      closeButtonText="Cancel"
    />
  );
};

export default RedeemCRCPointsPopup;
